var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white mt-3 mx-2",on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',{staticClass:"inline-block w-full"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }